import { useContext, useSyncExternalStore } from "react";
import { FinalizationContext } from "../../../providers/FinalizationProvider/FinalizationProvider";
import { finalizationInitialState, type TFinalizationState } from "../Finalization/Finalization";

/*
Synchronizes Finalization state to react state
 */
const useFinalizationState = (): TFinalizationState => {
    const { finalization } = useContext(FinalizationContext);

    return useSyncExternalStore(
        (onStoreChange) => {
            if (!finalization) return () => { };
            return finalization.subscribe(onStoreChange);
        },
        () => finalization?.selectDataExternally(x => x) ?? finalizationInitialState
    );
};

export default useFinalizationState;
